import { get } from 'lodash'
import { required, requiredCheck } from '../../../../utils/validation'

export default values => {
  const qualifications = requiredCheck(
    get(values, 'assessorActivityCategoryRegistration.universityDegree')
    || get(values, 'assessorActivityCategoryRegistration.tafeQualification')
    || get(values, 'assessorActivityCategoryRegistration.apprenticeship')
    || get(values, 'assessorActivityCategoryRegistration.experience')
    || get(values, 'assessorActivityCategoryRegistration.membership')
    || get(values, 'assessorActivityCategoryRegistration.nonAccreditedTraining')
    || get(values, 'assessorActivityCategoryRegistration.organisational')
    || get(values, 'assessorActivityCategoryRegistration.peakBody')
  )
  const errors = {
    assessorActivityCategoryRegistration: {
      membership: qualifications,
      relevantExperience: required(get(values, 'assessorActivityCategoryRegistration.relevantExperience'))
    }
  }

  return errors
}
